import { createRoute, Link } from '@tanstack/react-router';
import { AppBreadcrumbs } from '@/components/app/app-breadcrumbs.tsx';
import { InstallationsGrid } from '@/app/pages/installations-grid.tsx';
import { Button } from '@/components/ui/button.tsx';
import { usePageProps } from '@/hooks/use-page-props.ts';
import { layoutRoute } from '@/router/root-routes.tsx';
import { installations } from '@/app/pages/installations.ts';

export const hospitalityRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/installations-hospitality',
  component: HospitalityPage,
});

const hospitality = installations.filter((i) => i.type === 'hospitality');

function HospitalityPage() {
  usePageProps({ title: 'Hospitality Installations' });
  return (
    <div className="max-w-8xl mx-auto px-4">
      <AppBreadcrumbs items={[{ text: 'Home', href: '/' }, { text: 'Hospitality Installations' }]} />
      <h1 className="uppercase text-center mb-8">Hospitality Installations</h1>
      <InstallationsGrid items={hospitality} />
      <div className="text-center my-4 md:my-8">
        <Button asChild className="uppercase">
          <Link to="/installations-residential" viewTransition={true}>
            View Residential Installations
          </Link>
        </Button>
      </div>
    </div>
  );
}
